import { useFees } from '@/data/fee';
import { useRegions } from '@/data/region';
import { useTaxes } from '@/data/tax';
import { currencyFormat } from '@/helpers/stringHelpers';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const FeeBreakdown = () => {
  const fees = useFees();
  const regions = useRegions();
  const okanaganRegion = regions.data.find((r) => r.name === 'Okanagan');
  const taxes = useTaxes(okanaganRegion.id);

  if (taxes.isLoading && !taxes.data) {
    return null;
  }

  const exampleRate = 5000; // $50.00 in cents

  const formatPercentage = (value) => (value / 100).toFixed(2) + '%';

  const calculateFee = (rate, feeValue) => {
    return Math.round((feeValue / 10000) * rate);
  };

  const feeBreakdown = fees.data.reduce((acc, fee) => {
    acc[fee.label] = calculateFee(exampleRate, fee.value);
    return acc;
  }, {});

  const subTotal =
    exampleRate + Object.values(feeBreakdown).reduce((a, b) => a + b, 0);

  const taxBreakdown = taxes.data.reduce((acc, tax) => {
    acc[tax.label] = Math.round((subTotal * tax.rate) / 10000);
    return acc;
  }, {});

  const totalTax = Object.values(taxBreakdown).reduce((a, b) => a + b, 0);
  const clientRate = subTotal + totalTax;

  return (
    <Card className="max-w-[600px] mx-auto">
      <CardHeader>
        <CardTitle className="text-lg font-bold">
          Example Fee Breakdown
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between mb-3">
          <span>Example Coach Rate</span>
          <span>{currencyFormat(exampleRate)}</span>
        </div>

        {fees.data.map((fee) => (
          <div key={fee.id} className="flex justify-between">
            <span>
              {fee.label} ({formatPercentage(fee.value)})
            </span>
            <span>{currencyFormat(feeBreakdown[fee.label])}</span>
          </div>
        ))}

        <div className="flex justify-between mb-3">
          <span>Sub Total</span>
          <span className="font-bold">{currencyFormat(subTotal)}</span>
        </div>

        {taxes.data.map((tax) => (
          <div key={tax.id} className="flex justify-between">
            <span>
              {tax.label} ({formatPercentage(tax.rate)})
            </span>
            <span>{currencyFormat(taxBreakdown[tax.label])}</span>
          </div>
        ))}

        <div className="flex justify-between">
          <span>Grand Total</span>
          <span className="font-bold">{currencyFormat(clientRate)}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default FeeBreakdown;
